import { GenerateSummaryButton } from '@modules/oracle/components/GenerateSummaryButton';
import { Box, Stack } from '@mui/material';
import { SeeTopReasonInQuantifyButton } from '../SeeTopReasonInQuantifyButton';

interface GenerateSearchSummaryViewProps {
  shouldShowCooccurringDataPoints: boolean;
  onGenerateSummaryClick: () => void;
}

export const GenerateSearchSummaryView = ({
  shouldShowCooccurringDataPoints,
  onGenerateSummaryClick,
}: GenerateSearchSummaryViewProps) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Box flex={1} width="100%">
        <GenerateSummaryButton
          onClick={onGenerateSummaryClick}
          sx={{ py: 0.781, px: 1.875, lineHeight: 1.75, borderRadius: 1 }}
          typographyProps={{ variant: 'subtitle2' }}
        />
      </Box>
      <Box width="max-content" display="flex" justifyContent="flex-end">
        <SeeTopReasonInQuantifyButton
          shouldShowCooccurringDataPoints={shouldShowCooccurringDataPoints}
        />
      </Box>
    </Stack>
  );
};
